import React from 'react';
import {
  Button, DialogActions, DialogContent, DialogTitle, IconButton, Typography,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import AppDialog from '../../../shared/components/AppDialog';

const CONFIRM_COPY = Object.freeze({
  archive: {
    title: 'Archive target period?',
    message: '“{{name}}” will stop governing the Dashboard and become view-only history.',
    confirm: 'Archive',
  },
  delete: {
    title: 'Delete target period?',
    message: '“{{name}}” and its configured pathways will be permanently removed.',
    confirm: 'Delete',
  },
});

/** Confirm the two Target Configuration row actions: archive and delete. */
export default function TargetPeriodConfirmDialog({ action, onClose, onConfirm, open, period, t }) {
  const copy = CONFIRM_COPY[action] || CONFIRM_COPY.delete;
  const periodName = period?.name || period?.periodName
    || `${period?.baseYear}–${period?.targetYear} reduction plan`;

  return (
    <AppDialog fullWidth maxWidth={'xs'} onClose={onClose} open={open}>
      <DialogTitle sx={{ fontSize: 21, fontWeight: 850, pr: 7 }}>
        {t(`climateAction.target.${action}Title`, { defaultValue: copy.title })}
        <IconButton
          aria-label={t('common.close')}
          onClick={onClose}
          sx={{ position: 'absolute', right: 14, top: 12 }}
        >
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ px: 3, py: 2.25 }}>
        <Typography sx={{ fontSize: 14.5, lineHeight: 1.6 }}>
          {t(`climateAction.target.${action}Message`, {
            name: periodName,
            defaultValue: copy.message,
          })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button color={'inherit'} onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          color={action === 'delete' ? 'error' : 'primary'}
          disabled={!period}
          onClick={() => onConfirm(period, action)}
          variant={'contained'}
        >
          {t(`climateAction.target.${action}Confirm`, { defaultValue: copy.confirm })}
        </Button>
      </DialogActions>
    </AppDialog>
  );
}